import React from 'react'

const TermsPage: React.FC = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            Termini e Condizioni
          </h1>
          
          <div className="prose prose-lg text-gray-700">
            <p className="mb-4">
              <strong>Ultimo aggiornamento:</strong> 8 Agosto 2024
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              1. Accettazione dei Termini
            </h2>
            <p className="mb-4">
              Utilizzando il servizio La Dolce Vita, accetti di essere vincolato da questi Termini e Condizioni. 
              Se non accetti questi termini, non utilizzare il nostro servizio.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              2. Descrizione del Servizio
            </h2>
            <p className="mb-4">
              La Dolce Vita fornisce servizi di prenotazione di esperienze di viaggio, tour guidati e 
              attività turistiche nella regione Abruzzo. I nostri servizi includono:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Prenotazione di tour e attività</li>
              <li>Servizi di guida turistica</li>
              <li>Assistenza per la pianificazione del viaggio</li>
              <li>Servizi di supporto clienti</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              3. Registrazione e Account
            </h2>
            <p className="mb-4">
              Per utilizzare alcuni servizi, potresti dover creare un account. Sei responsabile di:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Mantenere la riservatezza delle tue credenziali</li>
              <li>Tutte le attività che si verificano nel tuo account</li>
              <li>Fornire informazioni accurate e aggiornate</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              4. Prenotazioni e Pagamenti
            </h2>
            <p className="mb-4">
              Le prenotazioni sono soggette a disponibilità. I pagamenti devono essere completati 
              al momento della prenotazione. Le tariffe sono espresse in Euro e includono l'IVA.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              5. Politica di Cancellazione
            </h2>
            <p className="mb-4">
              Le cancellazioni devono essere comunicate con almeno 24 ore di anticipo per ricevere 
              un rimborso completo. Cancellazioni tardive potrebbero comportare addebiti parziali.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              6. Responsabilità e Limitazioni
            </h2>
            <p className="mb-4">
              La Dolce Vita si impegna a fornire servizi di qualità, ma non possiamo garantire 
              che i servizi saranno sempre disponibili o privi di errori. La nostra responsabilità 
              è limitata al valore del servizio acquistato.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              7. Proprietà Intellettuale
            </h2>
            <p className="mb-4">
              Tutti i contenuti del sito web, inclusi testi, immagini, loghi e software, sono 
              protetti da copyright e appartengono a La Dolce Vita o ai nostri licenziatari.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              8. Informativa sui Cookie
            </h2>
            <p className="mb-4">
              Utilizziamo diversi tipi di cookie per migliorare la tua esperienza sul nostro sito:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Cookie tecnici:</strong> Necessari per il funzionamento del sito</li>
              <li><strong>Cookie di analytics:</strong> Per analizzare l'utilizzo del sito</li>
              <li><strong>Cookie di preferenze:</strong> Per ricordare le tue scelte</li>
              <li><strong>Cookie di marketing:</strong> Per contenuti personalizzati (solo con consenso)</li>
            </ul>
            <p className="mb-4">
              Puoi gestire le tue preferenze sui cookie attraverso il banner che appare sul nostro sito 
              o modificando le impostazioni del tuo browser. Tuttavia, la disabilitazione di alcuni cookie 
              potrebbe limitare la funzionalità del sito.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded mb-4">
              <p className="text-blue-700 text-sm">
                <strong>Per maggiori informazioni:</strong> Consulta la nostra 
                <a href="/privacy-policy#cookies" className="underline hover:text-blue-900 ml-1">
                  Informativa sulla Privacy
                </a> 
                per dettagli completi sui cookie e le tecnologie di tracciamento.
              </p>
            </div>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              9. Modifiche ai Termini
            </h2>
            <p className="mb-4">
              Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. 
              Le modifiche saranno effettive immediatamente dopo la pubblicazione.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              10. Legge Applicabile
            </h2>
            <p className="mb-4">
              Questi termini sono regolati dalla legge italiana. Qualsiasi controversia sarà 
              risolta dai tribunali competenti di Pescara, Italia.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              11. Contattaci
            </h2>
            <p className="mb-4">
              Per domande su questi termini, contattaci a:
            </p>
            <p className="mb-4">
              <strong>Email:</strong> legal@ladolcevita.com<br />
              <strong>Indirizzo:</strong> Via Roma 123, 65000 Pescara, Italia
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsPage 